import { SortingChannels } from 'constants/sorting'
import { StreamSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import React, { CSSProperties } from 'react'
import ProductTile from 'sharedComponents/ProductTileConnected/ProductTileConnected'
import { FallbackSkeleton } from 'uiComponents/molecules/ProductTile/FallbackSkeleton'
import MixedTileRowContainer from 'uiComponents/molecules/TileGrid/MixedTileRowContainer'
import { Tile } from 'uiComponents/molecules/TileGrid/RowBuilder'
import { FCRow } from 'uiComponents/molecules/TileGrid/TileGrid'

/**
 * This component is similar with {@link MixedTileRow}.
 *
 * It was necessary to create separate row builder since {@link MixedTileRow}
 * is tightly coupled to {@link useActiveSortChannel} and this fails
 * if page is reloaded on the drop details since no sorting store was created
 * or products by category id.
 *
 * The other difference that this component renders only standard {@link ProductTile}.
 *
 */
export const ProductTileRowWithoutSorting: FCRow<{
  tiles: Tile[]
  rowIndex: number
  rowIndexOffset: number
  loading?: boolean
  style?: CSSProperties
  overwriteSortChannelForTracking?: SortingChannels
}> = ({
  tiles,
  rowIndex,
  rowIndexOffset,
  loading,
  overwriteSortChannelForTracking,
  ...props
}) => {
  return (
    <MixedTileRowContainer data-testid="MixedTileRowContainer" {...props}>
      <StreamSectionTrackingContextProvider
        sectionIndexOnPage={rowIndex + rowIndexOffset}
        sortChannel={SortingChannels.UnSponsoredDefault}
      >
        {tiles.map((tile, index) => {
          if (!tile || !tile.id) {
            return <FallbackSkeleton key={index} />
          }
          const { id } = tile

          return (
            <ProductTile
              data-testid="ProductTile"
              disableTracking={loading}
              renderedInStream
              productId={id}
              key={`product-${id}`}
              indexInSection={index}
              preferredImageType
              importance={rowIndex === 0 ? 'high' : undefined}
            />
          )
        })}
      </StreamSectionTrackingContextProvider>
    </MixedTileRowContainer>
  )
}

ProductTileRowWithoutSorting.calcHeight = ({ listWidth, tilesPerRow }) => {
  return (listWidth / tilesPerRow) * 1.33 + 150
}
